var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "login-div" } },
    [
      _c(
        "b-alert",
        {
          staticClass: "mt-4",
          attrs: { show: _vm.ui.showError, variant: "danger" }
        },
        [_vm._v("\n    " + _vm._s(_vm.ui.showErrorMessage) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "mt-5",
          attrs: { show: _vm.ui.showSuccess, variant: "success" }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("ChangePassword.success")) + "\n    "
          ),
          _c("br")
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ui.showSuccess,
              expression: "ui.showSuccess"
            }
          ],
          staticClass: "mt-4"
        },
        [
          _c(
            "b-button",
            {
              staticClass: "btn-block",
              class: { "loading-ellipsis": _vm.isLoading },
              attrs: {
                disabled: _vm.isLoading,
                type: "submit",
                variant: "secondary"
              }
            },
            [_vm._v("\n      " + _vm._s(this.$t("Connecting")) + "\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.ui.showError && !_vm.ui.showSuccess
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "d-flex align-items-center mb-2 page-title",
                on: {
                  click: function($event) {
                    return _vm.backToLogin()
                  }
                }
              },
              [
                _c("h1", { staticClass: "page-title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("ChangePassword.newPassword")))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("ChangePassword.info", { mail: _vm.email })
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                ref: "form",
                staticClass: "mt-4",
                on: {
                  submit: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.handleSubmit.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("loginSecondCredential"),
                      "label-for": "password-input"
                    }
                  },
                  [
                    _c(
                      "b-input-group",
                      [
                        _c("b-form-input", {
                          ref: "password",
                          staticClass: "form-input-with-right-append-inside",
                          attrs: {
                            id: "password-input",
                            type: _vm.showPassword ? "text" : "password",
                            autocomplete: "off",
                            required: ""
                          },
                          model: {
                            value: _vm.form.newPassword.value,
                            callback: function($$v) {
                              _vm.$set(_vm.form.newPassword, "value", $$v)
                            },
                            expression: "form.newPassword.value"
                          }
                        }),
                        _vm._v(" "),
                        _c("b-input-group-append", [
                          _c(
                            "div",
                            {
                              staticClass: "cursor-pointer custom-eye",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.togglePassword.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              !_vm.showPassword
                                ? _c("i", {
                                    staticClass: "ph-custom ph-eye-fill"
                                  })
                                : _c("i", {
                                    staticClass: "ph-custom ph-eye-slash-fill"
                                  })
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-block",
                        class: { "loading-ellipsis": _vm.isLoading },
                        attrs: {
                          disabled: _vm.isLoading,
                          type: "submit",
                          variant: "primary"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.isLoading
                                ? _vm.$t("Connecting") + "..."
                                : _vm.$t("Validate")
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53a87082", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a87082","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/components/ResetPasswordComponent.vue
// module id = gVXw
// module chunks = 0